import { VitrinCourseDetail } from "@/models/course/VitrinCourseDetail";
import { fetchInstance } from "@/utils/fetchInstance";

export class WishlistService {
  static async getWishlist(
    params?: { page?: number; perPage?: number },
  ) {
    const searchParams = new URLSearchParams();
    if (typeof params?.page === "number") {
      searchParams.set("page", String(params.page));
    }
    if (typeof params?.perPage === "number") {
      searchParams.set("per_page", String(params.perPage));
    }
    const query = searchParams.toString();

    return fetchInstance<VitrinCourseDetail[]>(
      `vitrin/my-wishlist${query ? `?${query}` : ""}`,
      { method: "GET", auth: true },
    );
  }

  static async addToWishlist(
    miniAppUuid: string | number,
    courseId: string | number,
  ) {
    return fetchInstance<VitrinCourseDetail>(
      `mini-apps/${miniAppUuid}/courses/${courseId}/wishlist`,
      { method: "POST", auth: true },
    );
  }

  static async removeFromWishlist(
    miniAppUuid: string | number,
    courseId: string | number,
  ) {
    return fetchInstance<null>(
      `mini-apps/${miniAppUuid}/courses/${courseId}/wishlist`,
      { method: "DELETE", auth: true },
    );
  }

  static async toggleWishlist(
    miniAppUuid: string | number,
    courseId: string | number,
  ) {
    return fetchInstance<VitrinCourseDetail>(
      `mini-apps/${miniAppUuid}/courses/${courseId}/wishlist/toggle`,
      { method: "POST", auth: true },
    );
  }
}
